/* src/app/forms/wizard-configuracao/main-configuracao-grid-card/main-configuracao-grid-card.component.scss */
.main-configuracao-view {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.main-configuracao-view-port {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 5px;
  align-content: baseline;
}
.scroll-container {
  display: flex;
  max-height: 100%;
  height: 100%;
  overflow: auto;
  flex-direction: column;
  margin: 5px;
  justify-content: center;
}
.scroll-container-item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  z-index: 1;
  width: 100%;
  overflow-y: auto;
  flex-grow: 1;
  align-content: baseline;
}
.main-configuracao-view-port-item {
  display: flex;
  flex-direction: column;
  padding-right: 3px;
  padding-left: 3px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 25%;
}
@media (max-width: 1000px) {
  .main-configuracao-view-port-item {
    width: 50%;
  }
}
@media (max-width: 600px) {
  .main-configuracao-view-port-item {
    width: 100%;
  }
}
.title-card {
  position: relative;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 10px;
  width: 100%;
}
.item-actions {
  display: flex;
  width: 100%;
  gap: 10px;
  align-items: center;
  position: relative;
  height: 100%;
}
.mat-mdc-card-title {
  font-size: 1.5vw;
}
@media (max-width: 1000px) {
  .mat-mdc-card-title {
    font-size: 2vw;
  }
}
@media (max-width: 600px) {
  .mat-mdc-card-title {
    font-size: 3.5vw;
  }
}
.mat-mdc-card-content {
  font-size: 1.2vw;
  height: 100%;
}
@media (max-width: 1000px) {
  .mat-mdc-card-content {
    font-size: 1.7vw;
  }
}
@media (max-width: 600px) {
  .mat-mdc-card-content {
    font-size: 3.2vw;
  }
}
.full-width {
  width: 100%;
}
.accordion-align-header .mat-expansion-panel-header-description {
  justify-content: space-between;
  align-items: center;
}
.accordion-align-header .mat-mdc-form-field + .mat-mdc-form-field {
  margin-left: 8px;
}
.main-grid-view-filter {
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 10px;
}
.divider2 {
  height: 100%;
}
.grid {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.line {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  padding-top: 5px;
}
.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  padding-left: 3px;
  padding-right: 3px;
}
.column4 {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 4;
  padding-left: 3px;
  padding-right: 3px;
  padding-top: 5px;
}
.card-config {
  display: flex;
  flex-direction: column;
  min-height: 250px;
  max-height: 250px;
  height: 250px;
  margin: 5px;
}
.editMode {
  display: flex;
  flex-direction: column;
  height: 100%;
}
wizard-configuracao {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.summary {
  width: 100%;
  display: flex;
  padding: 4px;
  border: solid 1px;
  border-color: #bdc3c7;
  font-size: smaller;
  border-color: var(--ag-border-color, #bdc3c7);
}
.totalLines {
  padding-left: 12px;
}
.spacer {
  flex-grow: 1;
}
.lines {
  padding-right: 12px;
}
.add-button {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
}
.float-button {
  position: absolute;
  z-index: 100;
  right: 30px;
  bottom: 40px;
}
.refresh-button {
  position: absolute;
  z-index: 100;
  left: 30px;
  bottom: 40px;
  display: flex;
}
mat-toolbar {
  margin-top: 6px;
  margin-bottom: 6px;
}
@keyframes moveOne {
  from {
    bottom: 2rem;
    opacity: 0;
  }
  to {
    bottom: 6rem;
  }
}
@keyframes moveTwo {
  from {
    bottom: 2rem;
    opacity: 0;
  }
  to {
    bottom: 9rem;
  }
}
@keyframes movethree {
  from {
    bottom: 2rem;
    opacity: 0;
  }
  to {
    bottom: 12rem;
  }
}
.one {
  margin-bottom: 4px;
  bottom: 6rem;
  animation: moveOne 0.2s;
}
.two {
  margin-bottom: 4px;
  bottom: 9rem;
  animation: moveTwo 0.3s;
}
mat-card-footer {
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
}
.three {
  bottom: 12rem;
  animation: moveThree 0.3s;
  background-color: white;
  padding-right: 4px;
  padding-left: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
  border-radius: 16px;
  font-weight: 500;
  margin-bottom: 8px;
}
.dialog_scrim {
  background: black;
  opacity: 0.4;
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  z-index: 10;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header-title-card {
  display: flex;
  width: 100%;
}
/*# sourceMappingURL=main-configuracao-grid-card.component.css.map */
